export default [
  {
    title: 'Sales Submissions (Changi)',
    route: 'sales-changi-submissions',
    icon: 'FileTextIcon',
    resource: 'ChangiSalesSubmission',
    action: 'read',
    parent: 'sales',
  },
  {
    title: 'Submissions & Payments',
    route: 'sales-submissions',
    icon: 'ListIcon',
    resource: 'SalesSubmission',
    action: 'read',
    parent: 'sales',
  },
  {
    title: 'Sales Orders',
    route: 'sales-orders',
    icon: 'FileIcon',
    resource: 'SalesOrder',
    action: 'read',
    parent: 'sales',
  },
  {
    title: 'Retail Orders',
    route: 'sales-retail-orders-index',
    icon: 'ShoppingBagIcon',
    resource: 'RetailOrder',
    action: 'read',
    parent: 'sales',
  },
  {
    title: 'Transactions',
    route: 'sales-transactions-index',
    icon: 'RepeatIcon',
    resource: 'Transaction',
    action: 'read',
    parent: 'sales',
  },
]
